<script setup>
/** 全部节点的明细：毫秒、来源、节点名、距上一节点。图上看形状，这里查精确数。 */
import { computed } from 'vue'
import { Badge, Table } from '@drama/ui'
import { useI18n } from 'vue-i18n'
import { sourceVariant } from './timeline-source.js'

const props = defineProps({
  nodes: { type: Array, required: true },
})

const { t } = useI18n()

const columns = computed(() => [
  { key: 'at', label: t('visualGameAdmin.llm.turnTimelines.nodes.at'), width: '120px', align: 'right', mono: true },
  { key: 'source', label: t('visualGameAdmin.llm.turnTimelines.nodes.source'), width: '110px' },
  { key: 'name', label: t('visualGameAdmin.llm.turnTimelines.nodes.name'), width: '420px', wrap: true },
  { key: 'gap', label: t('visualGameAdmin.llm.turnTimelines.nodes.gap'), width: '140px', align: 'right', mono: true },
])

const rows = computed(() => props.nodes.map((node, index) => ({
  id: index,
  at: `@${Math.round(node.at_ms)} ms`,
  source: node.source,
  name: node.name,
  gapMs: index === 0 ? null : Math.round(node.at_ms - props.nodes[index - 1].at_ms),
})))
</script>

<template>
  <Table :columns="columns" :rows="rows">
    <template #source="{ row }">
      <Badge :variant="sourceVariant(row.source)">{{ t(`visualGameAdmin.llm.turnTimelines.sources.${row.source}`) }}</Badge>
    </template>
    <template #name="{ row }"><span class="vga-mono">{{ row.name }}</span></template>
    <template #gap="{ row }">
      <span v-if="row.gapMs !== null" :class="{ 'node-gap--long': row.gapMs >= 1000 }">+{{ row.gapMs }} ms</span>
    </template>
  </Table>
</template>

<style scoped>
.node-gap--long {
  color: var(--drama-color-danger);
  font-weight: 600;
}
</style>
